import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import businessInfo from '../businessInfo'


function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Dienstleistungen' },
    { to: '/prices', label: 'Preise' },
    { to: '/contact', label: 'Kontakt' }
  ]

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 p-2 -m-2 rounded-lg hover:bg-gray-100">
            <img src="/logo_simple.png" alt="Logo" className="h-10 w-auto" />
            <span className="font-bold text-xl text-gray-900">{businessInfo.displayCompanyName}</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-2">
            {navLinks.map((link) => {
              const isActive = link.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.to) && link.to !== '/';
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`
                    px-4 py-2.5 rounded-xl text-sm font-semibold transition-all hover:shadow-md
                    ${isActive
                      ? 'bg-yellow-500 text-blue-900 shadow-lg' 
                      : 'text-gray-700 hover:text-blue-900 hover:bg-blue-50'
                    }
                  `}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Mobile Button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {mobileOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu - Deine originale Logik */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 pt-4 pb-6 space-y-2">
            {navLinks.map((link) => {
              const isActive = link.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.to) && link.to !== '/';
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className={`
                    block px-4 py-3 rounded-xl font-semibold transition-all
                    ${isActive
                      ? 'bg-yellow-500 text-blue-900 shadow-md' 
                      : 'text-gray-700 hover:bg-blue-50 hover:text-blue-900'
                    }
                  `}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
